// Session de l'espace chauffeur, gardée dans localStorage :
//   { uid, session, driver: {id,name,company,vehicleType}, tenantName }
// `session` est un uuid opaque résolu côté serveur (utils/driverSession.js).

const KEY = "zeplan_driver";

export function loadDriverSession() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.uid || !parsed.session) return null;
    return parsed;
  } catch (e) {
    return null;
  }
}

export function saveDriverSession(data) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) {
    // stockage indisponible (navigation privée) : la session vit en mémoire
  }
}

export function clearDriverSession() {
  try {
    window.localStorage.removeItem(KEY);
  } catch (e) {
    // ignore
  }
}

// Lien vers l'espace depuis une page de suivi : ouvre une session via le jeton
// de suivi si le chauffeur n'en a pas encore.
export function driverAppUrlFromTrack(uid, token) {
  const s = loadDriverSession();
  if (s && s.uid === uid) return "/chauffeur";
  return `/chauffeur?uid=${encodeURIComponent(uid)}&track=${encodeURIComponent(token)}`;
}
